import { ProxyTypeName } from '@fd/common/biz/proxyType';
import { bytesToGb } from '@fd/common/biz/formatBytesToGb';
import { SubscriptionType } from '@fd/common/api/fetchSubscriptionList';
import { useSubscriptions } from './queries/useSubscriptions';
import { useEffect, useState } from 'react';
import { useAllTrafficUsed } from './queries/useAllTrafficUsed';

export const useTrafficGbAvailableByProxyType = (proxyType: ProxyTypeName) => {
  const [trafficAvailable, setTrafficAvailable] = useState(0);
  const subscriptions = useSubscriptions();
  const allTrafficUsed = useAllTrafficUsed();
  useEffect(() => {
    const subscriptionByProxyType = {
      mobile: new Array<SubscriptionType>(),
      residential: new Array<SubscriptionType>(),
      datacenter: new Array<SubscriptionType>(),
    };
    subscriptions.forEach((sub) =>
      subscriptionByProxyType[sub.proxyType.name].push(sub)
    );
    if (!allTrafficUsed) return undefined;
    let calcAvailableTrafficBytes = 0;
    for (const s of subscriptionByProxyType[proxyType]) {
      if (allTrafficUsed[s.id]) {
        calcAvailableTrafficBytes +=
          allTrafficUsed[s.id].bytes_allowed - allTrafficUsed[s.id].bytes_used;
      }
    }
    setTrafficAvailable(bytesToGb(calcAvailableTrafficBytes));
  }, [proxyType, subscriptions, allTrafficUsed]);

  return allTrafficUsed ? trafficAvailable : undefined;
};
